import Backbone from 'backbone'
import template from './input-test.hbs'
import DateInput from 'scoreboard/components/date-input'
import MarkedField from 'scoreboard/components/marked-field'
import select from 'scoreboard-select'
import dropdown from 'scoreboard/components/dropdown'
import LazyFilteringSelect from 'scoreboard/components/lazy-filtering-select'
import selects from 'scoreboard/components/selects'
import FileUploader from 'scoreboard/components/files/file-uploader'
import FileDrop from 'scoreboard/components/files/file-drop'
import DataType from 'scoreboard/datasets/model/data-type'
const { PERCENT, CURRENCY } = DataType

/**
 * Use a mock FileUploader for our FileDrop test here so we can bypass $.ajax calls.
 */
const MockFileUploader = FileUploader.extend({
	initialize(options) {
		FileUploader.prototype.initialize.apply(this, arguments)
		this.options.err = options.err
	},

	postFile() {
		// Simulate the progress and upload outcome
		let i = 1
		this.xhrInterval = setInterval(() => {
			let prog = i*20
			this.progress(prog)

			if (prog == 100) {
				clearInterval(this.xhrInterval)

				if (this.options.err) {
					this.error(this.options.err)
				} else {
					this.uploadFinished({})
				}
			}

			i++
		}, 400)
	}
})

var ColorsTestView = Backbone.View.extend({

	className: 'admin table-hack display-layout admin-test-view admin-test-inputs',

	render() {
		this.$el.empty().append(template())
		this._renderMarkedFields()
		this._renderSelects()
		this._renderFileUploaders()
		console.log('backstopjs_ready')
		return this
	},

	_renderMarkedFields() {
		// Set up date marked fields
		this.$('.marked-field-container input.date').each((i, el) => {
			var input = new DateInput({ el, initialValue: '2015-01-01' }).render()
			if (el.classList.contains('date-error')) {
				input.error('an error')
			}
		})

		// Set up currency marked fields
		this.$('.marked-field-container .regular input').each((i, el) => {
			new MarkedField({ el, markerContent: 'USD' }).render()
		})

		let validator = () => 'error'

		// Set up error marked fields
		this.$('.marked-field-container input.mark').each((i, el) => {
			new MarkedField({ el, validator }).render().error()
		})

		this.$('.marked-field-container input.disabled-test').each((i, el) => {
			new MarkedField({ el, markerContent: 'USD' }).render().disable()
		})

		// Set up text area errors
		this.$('.marked-field-container .errored textarea.error-mark').each((i, el) => {
				new MarkedField({ el, validator }).error('error').render()
		})
		this.$('.marked-field-container .errored textarea:not(.error-mark)').each((i, el) => {
			new MarkedField({ el }).render()
		})
	},

	_renderSelects() {
		this.$('select.has-error').each((i, el) => {
			new MarkedField({ el, validator: () => 'error' }).render().error()
		})

		select(this.el.querySelectorAll('select.simple-select-test'))

		let createFilteringSelect = selector => {
			let filterOptions = [{
				'label': 'Alabama',
				'value': 'AL'
			},{
				'label': 'Alaska',
				'value': 'AK'
			},{
				'label': 'American Samoa',
				'value': 'AS'
			}]

			selects.filtering(this.el.querySelectorAll(selector), {
				options: filterOptions.map(o => {
					// Massage the data here if you need to (ex. add an icon o.icon = <icon>)
					return o
				}),
				placeholder: 'Start typing...',
				render: {
					option: d => selects.optionHtml(d), // option in the dropdown
					item: d => selects.optionHtml(d) // selected item
				}
			})
		}

		createFilteringSelect('select.filter-example')


		new LazyFilteringSelect({
			el: this.$('.lazy-select'),
			// Each time a select is clicked on, pull the available/sorted
			// select options from _getOptionsWithSelected()
			getSelectOptions: () => {
				let arr = []
				let group = 'even'
				for (var i = 0; i < 2000; i++) {
					arr.push({
						label: 'this is a test - ' + i,
						value: 'this is a test - ' + i,
						group
					})
					group = (i%2 == 0) ? 'even' : 'odd'
				}
				return arr
			},
			filteringOptions: {
				groupBy: 'group'
			}
		}).render()

		let options = []
		let icons = ['docs', 'upload', 'delete', 'edit', 'metric', 'objective',
		'minimum', 'maximum', 'linked', 'docking', 'dataset', 'approved', 'rejected']

		for (var i = 0; i < icons.length; i++) {
			let icon = icons[i]
			options.push({
				id: icon,
				label: 'This is sample dropdown text!',
				icon
			})
		}
		dropdown.idLabels(this.$('select.dropdown-with-icons'), options, icons[0])

		// Marked Selects
		let createMarkedSelect = (i, dataType, currencyCode, disabled) => {
			let el = this.$(`.marked-select-${i}`)[0]
			select(el)
			let mf = new MarkedField({ el, dataType, currencyCode }).render()
			if (disabled) {
				mf.disable()
			}
			return mf
		}

		createMarkedSelect(1, CURRENCY, 'USD')
		createMarkedSelect(2, PERCENT)
		createMarkedSelect(3, CURRENCY, 'KES')
		createMarkedSelect(4, CURRENCY, 'USD')
		createFilteringSelect('select.marked-select-4')
		createMarkedSelect(5, PERCENT,null, true)
	},

	_renderFileUploaders() {
		this.$('.file-uploader-container .regular').append(new FileUploader({
			url: 'api/files/revision',
			data: () => {
				return {
					fileName: 'TEST-FORMCONTROL-FILE'
				}
			}
		}).render().el)

		var errorFileUploader = new FileUploader({
			url: 'api/files/revision'
		})

		this.$('.file-uploader-container .errored').append(errorFileUploader.el)
		errorFileUploader.render()
		errorFileUploader.error()

		let options = []
		let icons = ['docs', 'upload', 'delete', 'edit', 'metric', 'objective',
		'minimum', 'maximum', 'linked', 'docking', 'dataset']

		for (var i = 0; i < icons.length; i++) {
			let icon = icons[i]
			options.push({
				id: icon,
				label: 'This is sample dropdown text!',
				icon
			})
		}
		dropdown.idLabels(this.$('select.dropdown-with-icons'), options, icons[0])

		/**
		 * File Drop Tests
		 */

		let fd = new FileDrop({
			fileUploader: new MockFileUploader({ url: 'api/files/revision' })
		})
		this.$('.file-drop-container').append(fd.el)
		fd.render()

		let fdError = new FileDrop({
			dropLabel: 'Drop here to see what happens when a FileDrop has an error.',
			dropSubLabel: 'It should reset and trigger an error which we can use to show a banner.',
			fileUploader: new MockFileUploader({
				err: 'This is a test error. The FileDrop has been reset so that you can enter another file and try again.',
				url: 'api/files/revision'
			})
		})
		this.$('.file-drop-container-errored').append(fdError.el)
		fdError.render()
		fdError.on('error', err => {
				this.$('.file-drop-container-errored').addClass('has-error')
				this.$('.file-drop-container-errored .banner').html(err)
			})
			.on('start', () => {
				this.$('.file-drop-container-errored').removeClass('has-error')
				this.$('.file-drop-container-errored .banner').html('')
			})

		let fdAnimated = new FileDrop({
			animated: true,
			fileUploaderOptions: {
				url: 'api/files/revision',
				dataFn: () => {
					return {
						fileName: 'TEST-FORMCONTROL-FILE'
					}
				}
			}
		})
		this.$('.file-drop-container-animated').append(fdAnimated.el)
		fdAnimated.render()

		return this
	}
})

export default ColorsTestView
